export const NIP_STEPS = {
    INITIAL: 0,
    CREATE: 1,
    CONFIRM: 2,
    SUCCESS: 3,
} as const;

export type NipStep = typeof NIP_STEPS[keyof typeof NIP_STEPS];

export const PIN_LENGTH = 4;
